const QueryString = require('query-string')

export default (objects) => 
  QueryString.stringify(objects)